export const Scales = {
    scaleX: 0.82,
    scaleY: 0.593,
};
